import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { type TFact as TFactV2 } from '@app-evolution-cms/element-ui';

import type { DataLakeMetadata } from '../_api/request.type';

type DataLakeMetadataState = {
  dataLakeMetadata: DataLakeMetadata[] | undefined;
  getFactsV2: () => TFactV2[];
  getMentions: () => string[];
  reset: VoidFunction;
  updateDataLakeMetadata: (params: { dataLakeMetadata: DataLakeMetadata[] | undefined }) => void;
};

export const useDataLakeMetadataState = create<DataLakeMetadataState>()(
  persist(
    (set, get) => ({
      dataLakeMetadata: undefined,
      getFactsV2: () => {
        const metadataList = get().dataLakeMetadata ?? [];

        return metadataList
          .map((metadata) => {
            const codeDataTypeTmp = (metadata?.codeDataType?.toLowerCase() ?? 'string').trim();

            return {
              allowedValues: metadata?.allowedValues,
              attributeName: metadata.attributeName,
              codeDataType: codeDataTypeTmp,
              description: metadata.description,
            };
          })
          .sort((a, b) => a.attributeName.localeCompare(b.attributeName));
      },
      getMentions: () => {
        const metadataList = get().dataLakeMetadata ?? [];

        return metadataList
          .map((metadata) => metadata?.attributeName)
          .filter(Boolean)
          .sort((a, b) => a.localeCompare(b));
      },
      reset: () => set({ dataLakeMetadata: undefined }),
      updateDataLakeMetadata: ({
        dataLakeMetadata,
      }: {
        dataLakeMetadata: DataLakeMetadata[] | undefined;
      }) => set({ dataLakeMetadata }),
    }),
    { name: 'dl-metadata' },
  ),
);
